module.exports = __webpack_public_path__ + "static/img/weixin.11d9107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin.jpg
// module id = AVi7
// module chunks = 27